import { Component } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database';
import * as firebase from 'firebase/app';
import {Router} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
	user: Observable<firebase.User>;
	currentUser = {gamerTag:'', profileImage:''};
  currentUserId;
  dbUser;

  constructor(public afAuth: AngularFireAuth, public router: Router, db: AngularFireDatabase) {
    this.user = afAuth.authState;
	  this.afAuth.authState.subscribe(res => {
        if (res) {
          this.currentUserId = res.uid;
          this.dbUser = db.object('/staging/users/' + res.uid);
          this.dbUser.subscribe(user => {
            this.currentUser.gamerTag = user.gamerTag;
            this.currentUser.profileImage = user.photoURL;
            });
        }
        else {
          console.log('user not logged in');
          this.router.navigate(['/login']);
        }
	});
  }
  
  ngOnInit(){
  }

  logout() {
    this.currentUser = {gamerTag:'', profileImage:''};
    this.afAuth.auth.signOut();
  }
}



// WEBPACK FOOTER //
// d:/xampp/htdocs/zenith-admin/src/app/app.component.ts